/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Button, Collapse, Modal } from 'antd';
import { FaRegBuilding } from 'react-icons/fa';

import Utils from '../../Assets/Scripts/Utils';
import { api } from '../../Services/axiosService';

import styles from './VersionModal.module.scss';

export default function VersionModal({ setShowNewVersion }) {
  const modalFooter = (
    <div>
      <Button type="default" onClick={() => setShowNewVersion(false)}>
        Fechar
      </Button>
    </div>
  );

  const updateShowNewVersion = () => {
    try {
      const userData = JSON.parse(localStorage.getItem('conecta__userData') ?? {});

      if (userData?.showNewWebVersion) {
        const userId = userData.id;
        api.put(`/User/UpdateShowNewVersion?versionType=0&show=false&userId=${userId}`);
      }
    } catch (error) {
      Utils.logError(error);
    }
  };

  useEffect(() => {
    updateShowNewVersion();
  }, []);

  return (
    <Modal
      title="Novidades e ajustes"
      open={true}
      forceRender
      destroyOnClose={true}
      onCancel={() => setShowNewVersion(false)}
      footer={modalFooter}
      width="50%"
    >
      <div className={styles.versionModal}>
        <Collapse defaultActiveKey={['v7.3.0']} accordion>
          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v7.3.0"
            key="v7.3.0"
          >
            <h3>
              <strong>Agenda</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Na máscara do card da agenda, o nome passa a ser a razão social, no lugar do nome
                fantasia.
              </li>
            </ul>

            <h3>
              <strong>Lista de Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Na lista de treinamentos, os campos &quot;Razão de não faturamento&quot; e &quot;NF
                treinamento&quot; passam a permitir limpar e editar (inclusão e exclusão).
              </li>
            </ul>

            <h3>
              <strong>Integração Bitrix</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                A integração de campos com o Bitrix24 passa a aceitar anexos extras (mais de um
                anexo).
              </li>
            </ul>

            <h3>
              <strong>Produtos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                O dropdown de produtos passa a ter o tamanho ajustado e os itens passam a aparecer
                em ordem alfabética.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v7.2.0"
            key="v7.2.0"
          >
            <h3>
              <strong>Agenda</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-001 */}
              <li>
                No agendamento, os campos &quot;Placa&quot; e &quot;Quantidade&quot; passam a ter
                máscara de preenchimento.
              </li>

              {/* HHB-005 */}
              <li>
                O botão de copiar detalhes do treinamento passa a incluir data do treinamento,
                agendamento, quantidade de alunos, instrutor e instrutor auxiliar.
              </li>

              {/* HHB-008 */}
              <li>
                Na agenda e na lista de treinamentos, os produtos passam a poder ser encaixados em
                qualquer card, independente do grupo.
              </li>

              {/* HHB-009 */}
              <li>
                Na agenda e na lista de treinamentos, a identificação do cliente passa a usar a
                razão social (&quot;Cliente&quot;), em vez do nome fantasia.
              </li>

              {/* HHB-010 */}
              <li>
                No card da agenda, o nome do produto passa a ser um ícone, e o ícone de cliente
                passa a ser um texto em extenso.
              </li>

              {/* HHB-011 */}
              <li>
                Na máscara do card da agenda, passa a aparecer o ícone de transporte quando o
                transporte oficial está Incluso.
              </li>

              {/* HHB-014 */}
              <li>
                Na visualização do card da agenda, o identificador da turma passa a ser exibido no
                formato &quot;T34/40 - D1/3-NR23&quot;.
              </li>

              {/* HHB-022 */}
              <li>
                No card da agenda, o &quot;Nome Fantasia&quot; passa a aparecer no lugar do nome do
                produto.
              </li>
            </ul>

            <h3>
              <strong>Lista de Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-006 */}
              <li>
                Na lista de treinamentos, passam a existir os filtros &quot;Nome da empresa&quot;,
                &quot;ID do negócio&quot; e &quot;CNPJ&quot;.
              </li>
            </ul>

            <h3>
              <strong>Ocorrências</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-002 */}
              <li>As opções de ocorrências ficam ocultas para os papéis Motorista e Instrutor.</li>

              {/* HHB-007 */}
              <li>
                Criados o acesso pelo menu, a tela &quot;Gestão de ocorrência&quot; (grupo Cadastros
                Auxiliares) e o exportador de ocorrências.
              </li>
            </ul>

            <h3>
              <strong>Orçamento</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-003 */}
              <li>O PDF da proposta deixa de listar treinamentos com valor R$ 0,000.</li>

              {/* HHB-015 */}
              <li>
                Na tela de orçamento, o campo &quot;Transporte Específico&quot; passa a ficar
                desabilitado.
              </li>
            </ul>

            <h3>
              <strong>Exportador</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-017 */}
              <li>
                No exportador de dados, o campo de e-mail fica apenas em visualização, preenchido
                com o e-mail da tela de usuário.
              </li>

              {/* HHB-018 */}
              <li>O exportador Global passa a incluir a coluna &quot;Título&quot;.</li>
            </ul>

            <h3>
              <strong>Integração Bitrix</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-013 */}
              <li>
                Os campos &quot;Formulário do Instrutor&quot;, &quot;Necessidade do Cliente&quot;,
                &quot;Pós venda&quot;, &quot;Indústria&quot;, &quot;Tipo&quot; e &quot;Datas de
                Treinamento Oficial&quot; passam a integrar a Agenda e o Bitrix.
              </li>

              {/* HHB-021 */}
              <li>
                Integrados os campos &quot;Detalhamento Técnico&quot;, &quot;Pedido de Compra
                Oficial 2&quot; e &quot;Nome Fantasia&quot;.
              </li>
            </ul>

            <h3>
              <strong>Logística</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-000 */}
              <li>
                Alterada a unidade de capacidade do veículo: a quantidade passa a ser exibida em
                &quot;lugares&quot; (antes &quot;pessoas&quot;).
              </li>
            </ul>

            <h3>
              <strong>Fire Mobile</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-012 */}
              <li>Na agenda do centro Fire Mobile, passam a existir os tipos CT e LEAD.</li>
            </ul>

            <h3>
              <strong>Campos obrigatórios</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              {/* HHB-020 */}
              <li>
                A confirmação deixa de bloquear pelos itens &quot;NOME DO CLIENTE&quot; e &quot;OBS
                DO COMERCIAL&quot;.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v7.1.0"
            key="v7.1.0"
          >
            <h3>
              <strong>Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Ao selecionar motorista ou veículo, placa e nome passam a vir em campos abertos para
                edição no portal, sem ficar presos ao cadastro. A obrigatoriedade atrelada ao
                cadastro foi removida.
              </li>

              <li>
                Liberado o preenchimento do campo &quot;Reembolso&quot; mesmo após o treinamento
                concluído.
              </li>

              <li>
                Alterada a unidade de capacidade do veículo: a quantidade passa a ser exibida em
                &quot;lugares&quot; (antes &quot;pessoas&quot;).
              </li>

              <li>
                O e-mail de contato passa a ser preenchido automaticamente a partir do campo
                correspondente.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>
                No histórico de atividades, a ação passa a exibir o nome de quem executou, em vez de
                &quot;AUTOMAÇÃO&quot;.
              </li>

              <li>Instrutores inativos não aparecem mais na lista de seleção.</li>

              <li>Nomes de instrutores passam a ser exibidos apenas em maiúsculas.</li>

              <li>
                Na visão de cards, o primeiro treinamento agendado passa a aparecer corretamente e
                os horários dos slots não se sobrepõem.
              </li>
            </ul>

            <h3>
              <strong>Transporte</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                No e-mail de confirmação de transporte, o destinatário passa a ser o e-mail do
                cadastro da transportadora selecionada. O botão de escolha fica desativado; ainda é
                possível alterar o destinatário pelo aplicativo.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>É possível limpar o campo &quot;Motivo de Não Faturamento&quot;.</li>

              <li>
                Removida a exigência do campo &quot;NF&quot; de transporte na automação financeira.
              </li>
            </ul>

            <h3>
              <strong>Integração</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Alterações feitas nos campos do Bitrix (por exemplo, e-mail do responsável) passam a
                atualizar o portal de forma dinâmica, inclusive campos não editáveis na tela.
              </li>
            </ul>

            <h3>
              <strong>Ocorrências</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Acesso a &quot;Ocorrências&quot; liberado para todos os papéis, via configuração de
                permissões, para a opção aparecer no card.
              </li>
            </ul>

            <h3>
              <strong>Configurações</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>Corrigido o erro ao excluir um e-mail da Lista Negra de Destinatários.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v7.0.0"
            key="v7.0.0"
          >
            <h3>
              <strong>Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul>
              <li>
                Adicionado novo campo &quot;Localização&quot;, em formato de mapa, para selecionar o
                endereço do treinamento e preencher automaticamente os campos de endereço.
              </li>

              <li>
                Adicionado nova aba &quot;Comunicação&quot;, em formato de chat, para facilitar a
                comunicação entre Logística e Instrutor e Logística e Transportadora.
              </li>

              <li>
                Adicionado nova aba &quot;Percurso&quot;, para acompanhar o percurso de Instrutores
                e Motoristas ao local do treinamento.
              </li>

              <li>
                Modificado o campo de Veículos, agora para cada Motorista selecionado, pode ser
                vinculado um Veículo diretamente ao motorista.
              </li>

              <li>
                Adicionado os campos &quot;Nome Gestor&quot;, &quot;Telefone Gestor&quot;,
                &quot;Nome Logística&quot;, &quot;Telefone Logística&quot;, &quot;Nome
                Transporte&quot; e &quot;Telefone Transporte&quot;, no popup de envio de e-mails.
              </li>
            </ul>

            <h3>
              <strong>Lista de Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado nova funcionalidade para selecionar Localização do treinamento em massa.
              </li>

              <li>
                Ajuste no exportador da lista, agora gera o relatório em segundo plano e envia por
                e-mail.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Corrigido erro que ocorria ao salvar, quando tinha algum motorista vinculado ao
                treinamento mas o usuário não estava com o campo de motoristas visível.
              </li>

              <li>Corrigido erro silencioso que impedia de exportar a lista de treinamentos.</li>

              <li>
                Corrigido permissão que liberava acesso a funcionalidade &quot;Anexas
                Arquivos&quot;.
              </li>
            </ul>

            <h3>
              <strong>Agenda Instrutor</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Agora o formulário de Treinamento é igual ao da tela de Agendamento, com as mesmas
                funcionalidades disponiveis, além das funcionalidades especificas de Instrutor.
              </li>

              <li>
                Ajuste na regra de exibição dos campos, para refletir mesmo comportamento do
                aplicativo.
              </li>
            </ul>

            <h3>
              <strong>Agenda Motorista</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Agora o formulário de Treinamento é igual ao da tela de Agendamento, com as mesmas
                funcionalidades disponiveis, além das funcionalidades especificas de Motorista.
              </li>

              <li>
                Ajuste na regra de exibição dos campos, para refletir mesmo comportamento do
                aplicativo.
              </li>
            </ul>

            <h3>
              <strong>Permissões</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Agora nas permissões de campos, é possivel marcar os campos como &quot;Não
                Editáveis&quot;, desta forma só possibilita alterar a visibilidade dos campos, mas
                não editar.
              </li>
            </ul>

            <h3>
              <strong>Notificações</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Notificações de mensagens recebidas no chat de &quot;Comunicação&quot; do
                Treinamento, redirecionam diretamente para o formulário de treinamento com foco na
                aba Comunicação.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Agora redireciona corretamente para o treinamento, abrindo o formulário
                automaticamente em todas as agendas (Agendamento, Centro de Treinamento, Instrutor e
                Motorista).
              </li>
            </ul>

            <h3>
              <strong>Exportador</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado todos campos do Formulário do Treinamento que ainda não estavam no
                Exportador de Treinamentos.
              </li>

              <li>Adicionado novo exportador de Treinamentos Removidos.</li>

              <li>
                Ajuste no download dos relatórios, agora são gerados em segundo plano e enviados por
                e-mail.
              </li>
            </ul>

            <h3>
              <strong>Configurações</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Agora a tela de configurações é separada em abas, para facilitar a navegação e
                organização.
              </li>

              <li>
                Adicionado &quot;Lista Negra de Destinatários&quot;, &quot;E-mail IMAP&quot; e
                &quot;Porta IMAP&quot; na aba E-mail.
              </li>

              <li>
                Adicionado &quot;Contato Gestor&quot;, &quot;Contato Logística&quot; e &quot;Contato
                Transporte&quot; na aba Agenda.
              </li>

              <li>
                Adicionado aba &quot;Rastreamento do Treinamento&quot;, com as configurações de
                rastreamento.
              </li>

              <li>Adicionado configurações do Omie na aba Integrações.</li>
            </ul>

            <h3>
              <strong>Outros</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>Criado regra para não tentar enviar e-mail caso esteja vazio.</li>

              <li>
                Criado rotina para verificar falha nos envios de e-mails, e adicionar e-mails não
                existentes em Lista Negra, garantindo que não tente enviar novamente.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>Corrigido erro na importação de Empresas de Transporte por planilha.</li>

              <li>
                Corrigido erro que limpava o e-mail do usuário na atualização de dados através da
                tela Perfil.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v6.1.0"
            key="v6.1.0"
          >
            <h3>
              <strong>Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul>
              <li>
                Nova regra que determina os estágios automaticamente com base nos campos
                preenchidos. Caso os campos necessários para um estágio sejam removidos, o estágio
                volta. Os estágios &quot;Reservado Sem Confirmação&quot;, &quot;Confirmado&quot;,
                &quot;Negado&quot;, &quot;Reagendar&quot; e &quot;Distrato&quot;, continuam
                dependendo das ações manuais em tela.
              </li>

              <li>Adicionado novo estágio &quot;Aguardando Faturamento&quot;.</li>
            </ul>

            <h3>
              <strong>Agendamento</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado popup de Confirmação de treinamento, agora ao clicar em Confirmar ou Sem
                Contato com Cliente, irá abrir um popup para verificar se todos os campos
                obrigatórios para a confirmação foram preenchidos.
              </li>

              <li>
                Adicionado os campos: &quot;Observação Financeiro&quot;, &quot;Previsão de
                Chegada&quot;, &quot;Valor Turma&quot;, &quot;Valor Transporte&quot;, &quot;Valor
                Turma + Valor Transporte&quot;, &quot;Emissão Nota Fiscal Oficial&quot;.
              </li>

              <li>
                Adicionado regra que impede Alteração, Remoção, Reagendamento e outras ações em
                Treinamentos com estágio Concluído.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Corrigido problema que fazia com que em alguns casos o Estágio de um Treinamento era
                salvo como nulo.
              </li>

              <li>
                Agora e-mails enviados durante o processo de Integração e Agendamento, são enviados
                apenas para usuários ativos.
              </li>

              <li>
                Corrigido erro na troca de Centro de Treinamento na tela de Agendamento que
                ocasionava no não carregamento dos Slots adicionais, impedindo ações nos
                Treinamentos daquele Slot.
              </li>

              <li>
                Ajuste no salvamento dos filtros ao abrir a tela de Agendamentos através da tela
                Visão Geral, agora corretamente salva o Dia e Centro de Treinamento selecionados.
              </li>

              <li>
                Removido validação de e-mail no Formulário de Treinamento, agora só é validado no
                popup de envio de e-mails. Adicionado sanitização de e-mails no processo de
                integração para ajudar na padronização de múltiplos e-mails.
              </li>

              <li>
                Ajuste no carregamento da agenda durante a troca de datas, agora corretamente
                desabilita a agenda enquanto não termina a busca dos Treinamentos da data
                selecionada.
              </li>

              <li>
                Adicionado novas regras para impedir o Agendamento de Treinamentos em slots não
                compartilhados.
              </li>

              <li>
                Ajuste na exibição de campos de Transporte, agora não são mais exibidos quando o
                treinamento está marcado como &quot;Transporte Não Incluso&quot;.
              </li>
            </ul>

            <h3>
              <strong>Visão Geral</strong>
            </h3>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado total de Turmas e Alunos embaixo do nome de cada Centro de Treinamento.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>Agora Centros de Treinamento inativados são corretamente escondidos.</li>
            </ul>

            <h3>
              <strong>Lista de Treinamentos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado popup de Confirmação de treinamento, agora ao clicar em Confirmar ou Sem
                Contato com Cliente, irá abrir um popup para verificar se todos os campos
                obrigatórios para a confirmação foram preenchidos.
              </li>

              <li>
                Adicionado os campos: &quot;Observação Financeiro&quot;, &quot;Previsão de
                Chegada&quot;, &quot;Valor Turma&quot;, &quot;Valor Transporte&quot;, &quot;Valor
                Turma + Valor Transporte&quot;, &quot;Emissão Nota Fiscal Oficial&quot;.
              </li>

              <li>Adicionado nova funcionalidade para atualizar treinamentos por planilha.</li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>Ajuste na exibição das Datas ao entrar em modo de edição.</li>

              <li>
                Ajuste na exibição de campos de Transporte, agora não são mais exibidos quando o
                treinamento está marcado como &quot;Transporte Não Incluso&quot;.
              </li>
            </ul>

            <h3>
              <strong>Produtos</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>Adicionado campo Certificado.</li>

              <li>
                Adicionado nova funcionalidade para atualizar o Nome do Produto nos Treinamentos
                existentes no Portal quando ocorre alguma atualização do Nome no Catálogo de
                Produtos do Bitrix24.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>🐞</span> Correções
            </h4>

            <ul className={styles.bulletList}>
              <li>Correção da importação por planilha.</li>
            </ul>

            <h3>
              <strong>Usuários</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novos flags: &quot;Importação de Treinamentos p/ Planilha&quot; e
                &quot;Manipulação de qualquer Treinamento&quot;, que permitem respectivamente
                atualizar os treinamentos por importação de planilha e manipular treinamentos em
                qualquer estágio na tela Lista de Treinamentos.
              </li>
            </ul>

            <h3>
              <strong>Exportador</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>Adicionado a coluna Id no resultado.</li>
            </ul>

            <h3>
              <strong>Menu lateral</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>Ajuste para possibilitar abrir as páginas em outra aba com o botão direito.</li>

              <li>Realizado agrupamento de acessos, para facilitar a navegação.</li>

              <li>
                Adicionado novos acessos: &quot;Emissor Nota Fiscal&quot;, &quot;Motivo de
                Descarte&quot;, &quot;Motivo de Não Faturamento&quot;, &quot;Ocorrência&quot;,
                &quot;Tipo de Documento&quot;, &quot;Tipo de Ocorrência&quot;, &quot;Tipo de
                Veículo&quot;.
              </li>
            </ul>

            <h3>
              <strong>Novas Telas</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novas telas de Listagem e Cadastro de: &quot;Emissor Nota Fiscal&quot;,
                &quot;Motivo de Descarte&quot;, &quot;Motivo de Não Faturamento&quot;,
                &quot;Ocorrência&quot;, &quot;Tipo de Documento&quot;, &quot;Tipo de
                Ocorrência&quot;, &quot;Tipo de Veículo&quot;.
              </li>
            </ul>

            <h3>
              <strong>Outros</strong>
            </h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>✨</span> Novidades
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Melhorias de desempenho, agora a busca de registros, ações de Adicionar, Atualizar e
                Remover estão mais rápidas.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v5.0.0"
            key="v5.0.0"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Formulário de Treinamento
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Formulário de Treinamento redesenhado com várias melhorias de usabilidade e da
                interface.
              </li>

              <li>Formulário não fecha após realizar ações.</li>

              <li>
                É possível &quot;Confirmar&quot; o Treinamento após marcar como &quot;Sem Contato
                com Cliente&quot;.
              </li>

              <li>
                Adicionado novos campos: &quot;Não Possui Certificado&quot;, &quot;Diferença Alunos
                Confirmados/Treinados&quot;, &quot;Observação Omie&quot;.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Salvamento de Filtros
            </h4>

            <ul className={styles.bulletList}>
              <li>Foi adicionado a opção de Salvar os filtros na tela de Lista de Treinamentos.</li>

              <li>
                Foi adicionado um salvamento autmático de filtros na tela de Agenda Visão Geral e
                Agendamento, com opção para Limpar Filtros.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Novos Cadastros
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Foram adicionadas novas telas para realizar o Cadastro e Manutenção de: Empresas e
                Produtos.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> E-mails
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Novo disparo de E-mails automático para quando ocorrerem alterações na Observação do
                Negócio, notificando os times de Logística e Financeiro.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Visão Transporte
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Nova opção no cadastro do Usuário para informar se possui Visão Transporte ou não.
                Se possuir, todas as visões de Treinamentos são limitadas a treinamentos com
                Transporte Incluso ou de produto Transporte Extra.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Módulo Certificados
            </h4>

            <ul className={styles.bulletList}>
              <li>Agora existe um novo módulo dedicado a geração de Certificados.</li>

              <li>
                Novas opções na tela de Configurações, para configurar Modelos de Certificado.
              </li>

              <li>Nova tela para Configuração, Geração e Gestão de Certificados.</li>

              <li>
                Adicionado opções para: Importar Lista de Alunos, Configurar e Gerar Certificado no
                Formulário de Treinamento.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Integração
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Ajuste para garantir que Serviços com flag Aceito desmarcado sejam excluídos do
                Portal.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Responsáveis
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Ajuste para trazer todos Responsáveis do Bitrix24, independente se estão inativos ou
                não.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Treinamentos
            </h4>

            <ul className={styles.bulletList}>
              <li>Ajuste para não sobrescrever dados de Treinamentos durante atualização.</li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>

            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.6.9"
            key="v4.6.9"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Agendamento
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novos campos: &quot;Complemento&quot; e &quot;Produto -
                Complemento&quot;.
              </li>

              <li>
                Ajuste na exibição do Nome do Produto nos cartões de Treinamento, agora exibindo
                &quot;Nome Produto - Complemento&quot;.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.6.8"
            key="v4.6.8"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Lista de Treinamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>Nova tela para visualizar e manipular Treinamentos.</li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Visualização de Treinamentos em formato de lista, com possibilidade de configurar
                dinamicamente as colunas e exportar os registros filtrados.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Possbilidade de Editar, Confirmar, Reservar sem confirmação, Negar, Remover
                múltiplos treinamentos de uma vez.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Agendamento
            </h4>

            <ul className={styles.bulletList}>
              <li>Ajuste nos modelo de envio de e-mail de Treinamento e Transporte.</li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Adicionado duas novas opções de envio de e-mail no card de treinamento: Confirmação
                Instrutor, Confirmação Motorista.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Adicionado nova regra para impedir o agendamento de Instrutores em Treinamentos que
                não realizam.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Integração
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Correção na integração dos arquivos: Pedido de Compra, Termo de Aceite e Termo de
                Aceite Assinado. Agora eles são integrados corretamente, indicam Envio, Atualização
                e Remoção nas Atividades do Treinamento e também mudam Status para Reservado e
                Pré-Reservado conforme o Termo de Aceite Assinado é enviado ou removido.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Agendamento
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Ajuste nas permissões de todos uploads de Arquivos de Treinamento, agora
                corretamente permite/impede usuário de realizar o upload e remoção.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.4.2"
            key="v4.4.2"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado novos campos: &quot;Valor Instrutor Auxiliar&quot;, &quot;Número Nota
                Fiscal&quot;, &quot;Emissor Nota Fiscal&quot;, &quot;Valor Nota Fiscal Total&quot;,
                &quot;Valor Nota Fiscal Parcial&quot;
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador de Treinamentos
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novas colunas: &quot;VALOR INSTRUTOR AUXILIAR&quot;, &quot;NUMERO NOTA
                FISCAL&quot;, &quot;EMISSOR NOTA FISCAL&quot;, &quot;VALOR NOTA FISCAL TOTAL&quot;,
                &quot;VALOR NOTA FISCAL PARCIAL&quot;.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Integração
            </h4>
            <ul className={styles.bulletList}>
              <li>Melhoria na sincronia entre Bitrix24 e Portal.</li>
            </ul>

            <ul className={styles.bulletList}>
              <li>Regra para impedir duplicidade de Treinamentos.</li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.3.6"
            key="v4.3.6"
          >
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Agendamento
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Produtos que fazem parte do novo grupo de recurso &quot;Personalizado&quot;, podem
                ser Agendados em qualquer slot, respeitando apenas o Tipo de Treinamento (CT, In
                Company, EAD, Serviço).
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Produtos que fazem parte do novo grupo de recurso &quot;Personalizado&quot;, não
                contabilizam nos totais de alunos.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador de Treinamentos
            </h4>

            <ul className={styles.bulletList}>
              <li>
                Produtos personalizados, inclusive os que fazem parte do novo grupo de recurso
                &quot;Personalizado&quot;, tem a coluna &quot;QTD ALUNOS CONTRATADOS&quot; como 0,
                não contabilizando no total de alunos.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.3.5"
            key="v4.3.5"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador de Treinamentos
            </h4>

            <ul className={styles.bulletList}>
              <li>Adicionado nova coluna: &quot;CNPJ CLIENTE&quot;.</li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Produtos personalizados não contabilizam mais nos totais de alunos.</li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Corrigido um erro na busca dos Novos Slots que impedia treinamentos retroativos
                agendados em novos slots de serem modificados.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Corrigido um erro que impedia os dados salvos na tela de Configurações de serem
                atualizados no cache.
              </li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v4.3.0"
            key="v4.3.0"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado novo botão na parte superior esquerda do popup de Treinamento, para
                possibilitar o envio de E-mail de Confirmação de Treinamento e de Transporte
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novo botão na parte superior direita do popup de Treinamento, para
                possibilitar copiar detalhes importantes do Treinamento
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Configurações
            </h4>
            <ul className={styles.bulletList}>
              <li>Adicionado possibilidade de cadastrar Feriados e Pontos Facultativos</li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador de Treinamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado novo filtro para possibilitar trazer Treinamentos que não foram
                agendados.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novas colunas: &quot;POSSUI NF TREINAMENTO?&quot;, &quot;POSSUI NF
                TRANSPORTE?&quot;, &quot;DATA INTEGRAÇÃO&quot;.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Melhorias de desempenho.</li>
            </ul>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v3.4.27"
            key="v3.4.27"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Agora todos os campos e ações em um card de Treinamento geram histórico, separamos
                em duas abas de Atividades dentro do card, possibilitando ter a mesma visão de antes
                apenas com os dados mais importantes, ou uma visão detalhada com todas ações e
                alterações.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Agora é possível ver todas informações de um Treinamento através da &quot;lista de
                cards&quot; que fica a esquerda da tela, ao realizar uma ação de duplo clique em
                cima de qualquer card, o popup com todos os detalhes do treinamento é aberto em modo
                &quot;apenas visualização&quot;.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Adicionado novo campo &quot;Formulário do Instrutor&quot; dentro do popup de
                Treinamento, possibilitando o upload do formulário do instrutor.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Cadastro de Usuários
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Foram adicionadas travas para impedir erros ao vincular uma empresa a um usuário.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Instrutores
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado uma nova funcionalidade para importar uma planilha em Instrutores,
                possibilitando cadastrar múltiplos instrutores de uma vez só.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador de Treinamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>Adicionado nova coluna &quot;Lista de Presença Final&quot;.</li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Integração
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajustes para atualizar corretamente os dados no Bitrix24 e não disparar tantas vezes
                a integração sem necessidade.
              </li>
            </ul>

            <ul className={styles.bulletList}>
              <li>
                Ajuste para não sobrescrever os dados de um Treinamento quando vários treinamentos
                do mesmo negócio são atualizados em sequência.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Corrigido os filtros de busca de treinamentos, agora busca corretamente uma grande
                quantidade de registros e a opção de &quot;Selecionar Todos&quot; funciona
                corretamente.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Visão Geral
            </h4>
            <ul className={styles.bulletList}>
              <li>Ajuste na busca dos Feriados.</li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v3.2.3"
            key="v3.2.3"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Migração de Orçamento para Negócio
            </h4>
            <ul className={styles.bulletList}>
              <li>
                A partir do dia <strong>03/06/2024</strong>, todos os Treinamentos do Portal estão
                diretamente vinculados ao respectivo Negócio no Bitrix24.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Qualquer filtro antigamente realizado através do Código do Orçamento ou Nome do
                Orçamento, agora são realizados pelo Código do Negócio ou Nome do Negócio.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Todas as atualizações de informações que antes eram realizadas no Orçamento, agora
                são realizadas apenas nos campos de Negócio.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>Agora é possível realizar o envio de múltiplas Listas de Presença.</li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Treinamentos com Produtos Personalizados agora exibem o texto do campo
                &quot;Complemento&quot; preenchido na tela de Treinamentos do Bitrix24, não mais
                exibindo o texto &quot;Produto Personalizado&quot;.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Agora produtos que são do mesmo Grupo podem ser agendados no mesmo Slot, desta forma
                se um produto do grupo NR 23 estiver em um slot, é possível adicionar qualquer outro
                produto do grupo NR 23 no mesmo slot, respeitando as regras de
                Compartilhamento/Encaixe.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Ajuste nas Atividades exibidas dentro do card de Treinamento, agora todas as
                atividades exibirão claramente o usário que realizou a ação e também o avatar do
                mesmo.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v2.16.1"
            key="v2.16.1"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Reagendamento de Treinamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Mantivemos a antiga opção de Reagendamento dentro da opção de Remover para
                treinamentos que precisam ser ajustados na tela de Treinamentos do Bitrix24 e
                adicionamos uma nova opção mais rápida e prática.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajuste nos campos de caixa de texto, possibilitando a rolagem do texto corretamente.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>
                Adicionado um link direto para o Negócio no Bitrix24 dentro do card de Treinamento.
              </li>
            </ul>
            <ul className={styles.bulletList}>
              <li>Adicionado o campo Ponto de Referência dentro do card de Treinamento.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador
            </h4>
            <ul className={styles.bulletList}>
              <li>Adicionado novos campos no Exportador de Treinamentos.</li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v2.14.9"
            key="v2.14.9"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Melhoria na visualização do tooltip (exibido ao clicar uma vez no card ou no número
                de cards no slot).
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Agenda Centro de Treinamento
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Agora é possível filtrar qual CT está sendo visualizado nos filtros da agenda.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Autenticação
            </h4>
            <ul className={styles.bulletList}>
              <li>Agora é obrigatório a criação de senhas mais fortes.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Cadastro de Instrutores
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Agora os novos instrutores registrados terão um usuário criado automaticamente.
              </li>
            </ul>
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Cadastro de Usuários
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado novo campo no cadastro de usuários, para quando for do cargo CT poder
                vincular quais Centros de Treinamento são visíveis.
              </li>
            </ul>

            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v2.6.13"
            key="v2.6.13"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>Possibilidade de reservar múltiplas datas para os instrutores.</li>
              <li>
                Melhoria na visualização do Resumo, agora os cards são agrupados por slot e podem
                ser abertos diretamente pela tela de resumo.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Visão Geral
            </h4>
            <ul className={styles.bulletList}>
              <li>Novo filtro de Centro de Treinamento.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Exportador
            </h4>
            <ul className={styles.bulletList}>
              <li>Exportação de treinamentos para excel.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Cadastros/Listas: Intrutor e Centro de
              Treinamento.
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Os formulários de cadastro foram ajustados, as abas e campos foram reorganizadas, o
                cadastro de documento foi melhorado e agora é possivel ver quais os documentos
                obrigatórios.
              </li>
              <li>
                Nas listas foi adicionado uma nova coluna para informar se o registro possui todos
                os documentos obrigatórios.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Configurações
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Possibilidade de informar quais documentos são obrigatórios em cada formulário.
              </li>
            </ul>

            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v1.5.2"
            key="v1.5.2"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos e Agenda Centro de
              Treinamento
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajuste no upload de Lista de Presença Inicial e Final, agora é possível realizar o
                upload de qualquer tipo de arquivo, sem bloqueios, necessitando preencher os campos
                Alunos Confirmados e Alunos Treinados manualmente.
              </li>
            </ul>
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos e Agenda Centro de
              Treinamento
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajuste nos links de Pedido de Compra, Termo de Aceite e Termo de Aceite Assinado.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v1.4.10"
            key="v1.4.10"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Agora, na visão da Logística no card de Treinamento, é possível utilizar o botão de
                Salvar, e o botão Confirmar passou a salvar os dados do formulário também.
              </li>
              <li>
                Ajuste no modelo de Lista de Presença, agora só são obrigatórios os campos Nome e
                CPF, e opcional o CNPJ.
              </li>
            </ul>
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Integração
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajustado a atualização dos campos Data do Primeiro Treinamento, Datas de Treinamento
                e Endereço do CT.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>Ajuste na busca dos registros de Resumo e Overview.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Notificações
            </h4>
            <ul className={styles.bulletList}>
              <li>Correção no redirecionamento das Notificações.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Instrutores
            </h4>
            <ul className={styles.bulletList}>
              <li>Correção na deleção de Instrutores.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Implementação de um novo sistema de monitoramento de erros e performance.</li>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v1.2.4"
            key="v1.2.4"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agenda Visão Geral
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado indicador na data, exibindo um alerta e destacando na cor laranja para
                Pontos Facultativos e vermelho para Feriados, ao passar o mouse em cima é possível
                ver o nome do Ponto Facultativo/Feriado.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Melhoria visual no popup de Confirmação de Agendamento, agora é possível confirmar o
                Nome do CT, Nome da Empresa e Data.
              </li>
              <li>
                Liberado novamente a possibilidade de agendar treinamentos retroativos, exibindo
                somente um alerta já que não é recomendado.
              </li>
            </ul>
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Permissões
            </h4>
            <ul className={styles.bulletList}>
              <li>Ajustes nas permissões de acesso.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Ajuste no carregamento das telas.</li>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>

          <Collapse.Panel
            className="configuration-divider"
            orientation="left"
            header="v1.1.1"
            key="v1.1.1"
          >
            <h3>Novidades</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Adicionado ícone <FaRegBuilding /> e ao passar o mouse em cima deste ícone exibe o
                Nome do Cliente.
              </li>
              <li>
                Adicionado opção &quot;Reagendamento&quot; ao remover um treinamento da agenda.
              </li>
              <li>
                Melhoria na visibilidade da barra de rolagem dentro do popup exibido quando têm mais
                de 4 treinamentos compartilhados no mesmo slot.
              </li>
              <li>
                Adicionado um indicador na parte de baixo dos slots que possuem 2 ou mais
                treinamentos compartilhados, exibindo o total de alunos de todos os treinamentos no
                slot.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Cadastro de Centros de Treinamento
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Agora é possível adicionar o Recurso do tipo &quot;Serviço&quot;, permitindo
                escolher quantas colunas e slots estarão disponíveis para aquele CT na tela
                Agendamento.
              </li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Visualização de Campos e Permissões
            </h4>
            <ul className={styles.bulletList}>
              <li>A Visualização de Campos e as Permissões agora são atualizados em tempo real.</li>
            </ul>
            <h3>Correções/Ajustes</h3>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agendamentos
            </h4>
            <ul className={styles.bulletList}>
              <li>
                Ajustado a responsividade dos cards de Treinamento, melhorando a visibilidade das
                informações.
              </li>
              <li>Correção no agendamento de treinamentos no dia 29/02.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Tela Agenda Visão Geral
            </h4>
            <ul className={styles.bulletList}>
              <li>Correção na disponibilidade da agenda nos domingos.</li>
            </ul>
            <h4 className={styles.subtitle}>
              <span className={styles.symbol}>📌</span> Outros
            </h4>
            <ul className={styles.bulletList}>
              <li>Correções de bugs e outros ajustes.</li>
            </ul>
          </Collapse.Panel>
        </Collapse>
      </div>
    </Modal>
  );
}
